import { render, staticRenderFns } from "./searchItemList.vue?vue&type=template&id=b94fb19e"
import script from "./searchItemList.vue?vue&type=script&lang=js"
export * from "./searchItemList.vue?vue&type=script&lang=js"
import style0 from "./searchItemList.vue?vue&type=style&index=0&id=b94fb19e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CommonImg: require('/root/workspace/web-company_Yo6Q/components/common/commonImg.vue').default})
